import { RemoteProfession } from 'data/usecases';
import { HandleProfessionListUseCaseInterface } from 'domain/usecases';
import { makeApiUrlProfession } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeHandleProfessionList =
  (): HandleProfessionListUseCaseInterface =>
    new RemoteProfession(makeApiUrlProfession(), makeAxiosHttpClient());
